import { Link } from 'react-router-dom';
import NumberFormat from "react-number-format";

import './form_/form.css';
import './form_/tabla.css';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { comprasLoadDetail } from '../../redux/actions/compras';
import { useState } from 'react';
import { Model } from '../../models/model';

export const ListaDeGastos = ({ list, iniCargarCompras }) => {

    const dispatch = useDispatch();
    const { items: itemsPppto } = useSelector(state => state.ppto.detail)

    const onClickDetail = (item) => {
        let detail = item;
        detail.items = [];
        dispatch(comprasLoadDetail(detail));
    }

    return (
        <div className='p-pptos'>
            <div className='row'>

                {list?.length > 0 ?
                    <div className="table-responsive">
                        <table className="table p-table-global">
                            <thead className='p-thead-global'>
                                <tr className="text-center p-tr-titles-global">
                                    <th scope="col">Número</th>
                                    <th scope="col">Estado</th>
                                    <th scope="col">Fecha</th>
                                    <th scope="col" className='text-start'>Proveedor</th>
                                    <th scope="col" className='text-start'>Item ppto</th>
                                    <th scope="col" className='text-start'>Descripción del gasto</th>
                                    <th scope="col" className='text-end'>Monto Base</th>
                                    <th scope="col" className='text-end'>Impuesto</th>
                                    <th scope="col" className='text-end'>Total</th>
                                    <th scope="col" className='text-end'>Pagado</th>
                                    <th scope="col" className='text-end'>Por pagar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {list?.map(item => (
                                    <RowOne
                                        item={item}
                                        onClickDetail={onClickDetail}
                                        itemsPppto={itemsPppto}
                                        iniCargarCompras={iniCargarCompras}
                                    />
                                ))
                                }
                            </tbody>
                        </table>

                    </div>
                    :
                    <h2 className='text-[16px] mt-2'>No hay gastos asociados.</h2>
                }

            </div>
        </div>
    )
}

const RowOne = ({ item, onClickDetail, itemsPppto, iniCargarCompras }) => {
    console.log({ item })

    const [showList, setShowList] = useState(false)

    const handleChangeBuy = async ({ target }, id_gasto, origen) => {
        const itemId = target.value

        await Model.update({
            url: `compras/cambiar-gasto-item/${id_gasto}`,
            dataForm: {
                id_gasto: id_gasto,
                id_item_ppto_new: itemId,
                origen
            }
        })

        await iniCargarCompras()
        setShowList(false)

    }


    return (
        <tr
            key={item.id}
            onClick={() => onClickDetail(item)}
            className="p-tr-body-global"
            style={{ height: '65px' }}
        >
            <td className="text-center" >
                <Link className='LinkTable d-flex flex-column justify-content-start align-items-start' to={`/gastos/compras/${item.id}`}>
                    <span>OS #{item.numero || '00000'}</span>
                    <span style={{ fontSize: '10px' }} className='text-start'>{item.nombre_tipo_documento || '--'}</span>

                    {parseInt(item.flow_id) > 0 ?
                        <span style={{ fontSize: '9px', marginTop: '10px' }}>tiene flujo</span> : ''
                    }

                </Link>
            </td>
            <td className="text-center">
                <Link className='LinkTable' to={`/gastos/compras/${item.id}`}>
                    <div className='d-flex justify-content-center'>
                        {item.estado === 'emitida' &&
                            <span className='p-label-estado p-emitida'>Emitida</span>
                        }
                        {item.estado === 'pagada' &&
                            <span className='p-label-estado p-pagada'>Pagada</span>
                        }
                        {item.estado === 'anulada' &&
                            <span className='p-label-estado p-anulada'>Anulada</span>
                        }
                    </div>
                </Link>
            </td>
            <td className="text-center" >
                <Link className='LinkTable' to={`/gastos/compras/${item.id}`}>
                    {moment(item.fecha_emision).format('DD-MM-YYYY') || 'ninguno'}
                </Link>
            </td>
            <td className="text-start">
                <Link className='LinkTable' to={`/gastos/compras/${item.id}`}>
                    {item.razon_social || 'ninguno'}
                </Link>
            </td>
            <td className="text-start">
                <div className='d-flex flex-column justify-content-start align-items-start' style={{ position: 'relative' }}>
                    <Link className='LinkTable' to={`/gastos/compras/${item.id}`}>
                        {item.origen_descripcion_item_ppto || 'sin info'}
                    </Link>

                    {!showList ?
                        <Link
                            to=""
                            className='p-link-open-dialog'
                            onClick={() => setShowList(true)}
                            style={{
                                fontSize: '10px',
                                position: 'absolute',
                                bottom: '-18px',
                                color: '#8E24AA'
                            }}>
                            mover gasto
                        </Link> : ''
                    }

                </div>

                {showList ?
                    <div className='d-flex flex-column align-items-end'>

                        <label>
                            <span style={{ fontSize: '10px' }}>Mover a:</span>
                            <select
                                name="filter"
                                className='mt-3 ms-2'
                                style={{ color: 'gray', boder: '1px solid red', textTransform: 'capitalize' }}
                                onChange={(e) => handleChangeBuy(e, item.id, item.origen)}
                            >
                                <option selected value="todas-no-nulas" style={{ color: 'gray' }}>--Seleccionar ítem--</option>
                                {itemsPppto.map(title => (
                                    <>
                                        <option key={title.id} value={title.id} disabled>{title.nombre}</option>
                                        {title.items.map(item => (
                                            <option key={item.id} value={item.id}>-- {item.nombre}</option>
                                        ))}
                                    </>
                                ))}
                            </select>
                        </label>
                        <Link
                            to=""
                            className='p-link-open-dialog'
                            onClick={() => setShowList(false)}
                            style={{
                                fontSize: '10px',
                                color: '#8E24AA',
                                marginTop: '10px'
                            }}>
                            cancelar
                        </Link>

                    </div> : ''
                }

            </td>
            <td className="text-start">
                <Link className='LinkTable' to={`/gastos/compras/${item.id}`} >
                    <p>{item.referencia || 'ninguno'}</p>
                </Link>
            </td>
            <td className="text-end">
                <Link className='LinkTable' to={`/gastos/compras/${item.id}`} >
                    <NumberFormat
                        value={item.monto_base ? parseFloat(item.monto_base) : 0}
                        displayType={'text'}
                        thousandSeparator={item.separacion_miles}
                        decimalSeparator={item.separacion_decimales}
                        prefix={`${item.simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </Link>
            </td>
            <td className="text-end">
                <Link className='LinkTable' to={`/gastos/compras/${item.id}`} >
                    <NumberFormat
                        value={item.total_impuesto ? parseFloat(item.total_impuesto) : 0}
                        displayType={'text'}
                        thousandSeparator={item.separacion_miles}
                        decimalSeparator={item.separacion_decimales}
                        prefix={`${item.simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </Link>
            </td>
            <td className="text-end">
                <Link className='LinkTable' to={`/gastos/compras/${item.id}`} >
                    <NumberFormat
                        value={item.total_compra ? parseFloat(item.total_compra) : 0}
                        displayType={'text'}
                        thousandSeparator={item.separacion_miles}
                        decimalSeparator={item.separacion_decimales}
                        prefix={`${item.simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </Link>
            </td>
            <td className="text-end">
                <Link className='LinkTable' to={`/gastos/compras/${item.id}`} >
                    <NumberFormat
                        value={item.total_pagado ? parseFloat(item.total_pagado) : 0}
                        displayType={'text'}
                        thousandSeparator={item.separacion_miles}
                        decimalSeparator={item.separacion_decimales}
                        prefix={`${item.simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </Link>
            </td>
            <td className="text-end">
                <Link className='LinkTable' to={`/gastos/compras/${item.id}`} >
                    <NumberFormat
                        value={item.total_por_pagar ? parseFloat(item.total_por_pagar) : 0}
                        displayType={'text'}
                        thousandSeparator={item.separacion_miles}
                        decimalSeparator={item.separacion_decimales}
                        prefix={`${item.simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </Link>
            </td>
        </tr>
    )

}